export const isComingSoon = process.env.NEXT_PUBLIC_COMING_SOON === "true";
